<template>
  <div class="row no-gutters h-100">
    <div class="col-sm-8 h-100">
      <slot name="default" :section="section"></slot>
    </div>
    
    <KeyNav :keyLevel="3" :size="sections.length" :defaultIndex="index" @selected="useSection" @deselected="escaped" @preselected="preselected" class="col-sm-4 h-100">
      <template v-slot:default="{ preselected }">
        <div class="sections__list">
          <div class="list-group" :ref="'sections'">
            <div v-for="(section, idx) in sections" :key="idx" @click="useSection(idx)" class="list-group-item" :class="[{ active: idx === index, 'list-group-item-dark': preselected === idx }]">
              <slot name="preview" :section="section"></slot>
            </div>
          </div>
        </div>

        <div class="sections__toolbar">
          <b-button @click="decreaseSection">
            <b-icon-dash></b-icon-dash>
          </b-button>

          <span class="pane-toolbar__current">{{ sections[index].title }}</span>

          <b-button @click="increaseSection">
            <b-icon-plus></b-icon-plus>
          </b-button>
        </div>
      </template>
    </KeyNav>
  </div>
</template>

<script>
  import KeyNav from './KeyNav'

  export default {
    props: {
      sections: {
        type: Array
      }
    },

    components: { KeyNav },

    data() {
      return {
        index: 0
      }
    },

    watch: {
      sections() {
        this.index = 0
      }
    },

    computed: {
      section() {
        return this.sections[this.index]
      }
    },

    methods: {
      decreaseSection() {
        if (this.index !== 0) {
          this.index--;
        }
      },

      increaseSection() {
        if (this.index !== this.sections.length - 1) {
          this.index++;
        }
      },

      useSection(index) {
        this.index = index
        this.$emit('sectioned', index);
      },

      preselected(index) {
        this.$refs.sections.children[index].scrollIntoViewIfNeeded();
      },

      escaped() {
        this.$emit('escaped');
      }
    }
  }
</script>

<style scoped>
  .row > :first-child {
    border-right: 1px solid #ccc;
  }

  .row > :last-child {
    border-left: 1px solid #eee;
  }

  .col-sm-8, .col-sm-4 {
    position: relative;
  }

  .sections__list {
    position: relative;
    height: calc(100% - 3em);
  }

  .sections__list .list-group {
    position: absolute;
    height: 100%;
    width: 100%;
    overflow: auto;
  }

  .sections__list .list-group-item {
    font-size: 0.85em;
    cursor: pointer;
  }

  .sections__list .list-group-item.active {
    color: inherit;
    background-color: #ddd;
    border-color: #ddd;
  }

  .sections__list .list-group-item > div {
    min-height: 10em;
    max-height: 20em;
  }

  /deep/ .sections__list .list-group-item br:first-child:last-child {
    display: none;
  }

  .sections__toolbar {
    position: absolute;
    bottom: 0;
    width: 100%;

    height: 3em;

    background: #CCC;

    display: flex;
    align-items: center;
    justify-content: center;
  }
</style>